import { render, staticRenderFns } from "./SelectDrugParasite.vue?vue&type=template&id=6a338980"
import script from "./SelectDrugParasite.vue?vue&type=script&lang=js"
export * from "./SelectDrugParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports